import { useStackRoles } from 'data/hooks/roles'

import { getUserRoleLabel } from './getUserRoleLabel'

export function useGetRoleLabel(api_name?: string | undefined): string | undefined {
    const { data: roles } = useStackRoles()
    return getUserRoleLabel(api_name, roles)
}
